<template>
    <v-form>
        <v-row v-show="!!formComponent">
            <template v-if="productType === 'FLIGHT'">
                <v-col cols="4">
                    <airlines-search-input
                        v-model="product.marketingAirline"
                        class="mt-4"
                        outlined
                        dense
                        :label="`${$t('flights.airline')}`"
                        hide-details
                    />
                </v-col>
                <v-col cols="12" class="py-0">
                    <div class="full-width d-flex align-center">
                        <v-spacer />
                        <flight-route-import-dialog
                            @change-end-date="changeEndDate($event)"
                            @change-start-date="changeStartDate($event)"
                            @change-segments="product.segments = $event"
                        />
                        <v-btn class="ms-2" color="primary" size="small" @click="addSegment">
                            <v-icon> mdi-plus </v-icon>
                        </v-btn>
                    </div>
                </v-col>
                <v-col v-for="(segment, index) in product.segments" :key="index" cols="12">
                    <div class="d-flex align-start full-width">
                        <component
                            :is="formComponent"
                            v-model="product.segments[index]"
                            class="full-width"
                            :index="index"
                            :product-type="productType"
                            :tourists="tourists"
                        />
                        <v-btn
                            v-if="product.segments && product.segments.length !== 1"
                            class="mt-n4"
                            size="small"
                            elevation="0"
                            @click="removeSegment(index)"
                        >
                            <v-icon> mdi-close </v-icon>
                        </v-btn>
                    </div>
                    <v-divider class="my-8" />
                </v-col>
            </template>
            <v-col v-else cols="12" class="py-8">
                <component :is="formComponent" v-model="product" :product-type="productType" :tourists="tourists" />
            </v-col>
        </v-row>
    </v-form>
</template>

<script lang="ts">
    import {Component, Emit, Prop, VModel, Vue} from 'vue-facing-decorator'
    import OfflineServiceFormFlight from '@/components/account/offlineServices/forms/OfflineServiceFormFlight.vue'
    import OfflineServiceFormAccommodation from '@/components/account/offlineServices/forms/OfflineServiceFormAccommodation.vue'
    import OfflineServiceFormTransfer from '@/components/account/offlineServices/forms/OfflineServiceFormTransfer.vue'
    import OfflineServiceFormCars from '@/components/account/offlineServices/forms/OfflineServiceFormCars.vue'
    import OfflineServiceFormCruise from '@/components/account/offlineServices/forms/OfflineServiceFormCruise.vue'
    import OfflineServiceFormExcursion from '@/components/account/offlineServices/forms/OfflineServiceFormExcursion.vue'
    import AirlinesSearchInput from '@/components/snippets/AirlinesSearchInput.vue'
    import FlightRouteImportDialog from '~/components/account/offlineServices/FlightRouteImportDialog.vue'

    @Component({
        components: {
            AirlinesSearchInput,
            OfflineServiceFormExcursion,
            OfflineServiceFormCars,
            OfflineServiceFormCruise,
            OfflineServiceFormTransfer,
            OfflineServiceFormAccommodation,
            OfflineServiceFormFlight,
            FlightRouteImportDialog,
        },
    })
    export class OfflineServiceProductForm extends Vue {
        @Prop() productType
        @Prop() tourists
        @VModel() product

        @Emit()
        changeStartDate(date) {
            return date
        }

        @Emit()
        changeEndDate(date) {
            return date
        }

        addSegment() {
            this.product.segments?.push({brandedFare: {name: ''}})
        }

        async removeSegment(i) {
            //rerender because of index-key
            const clonedSegments = clone(this.product.segments)
            clonedSegments?.splice(i, 1)
            this.product.segments = []
            await this.$nextTick()
            this.product.segments = clonedSegments
        }

        get formComponent() {
            switch (this.productType) {
                case 'FLIGHT':
                    return resolveComponent('OfflineServiceFormFlight')
                case 'ACCOMMODATION':
                    return resolveComponent('OfflineServiceFormAccommodation')
                case 'TRANSFER':
                    return resolveComponent('OfflineServiceFormTransfer')
                case 'CAR_RENT':
                    return resolveComponent('OfflineServiceFormCars')
                case 'EXCURSION':
                    return resolveComponent('OfflineServiceFormExcursion')
                case 'CRUISE':
                    return resolveComponent('OfflineServiceFormCruise')
                default:
                    return null
            }
        }
    }

    export default OfflineServiceProductForm
</script>
